<template>
  <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
    <a-form-model
      size="small"
      layout="inline"
      :model="ajaxparams"
      @keyup.native.enter="$refs.myTable.search()"
    >
      <a-form-model-item label="商品名称">
        <a-input
          v-model="ajaxparams.goods_name_no"
          allow-clear
          placeholder="输入关键字"
          style="width: 180px"
        />
      </a-form-model-item>
      <a-form-model-item label="业务经理姓">
        <a-input
          v-model="ajaxparams.manager_name_no"
          allow-clear
          placeholder="输入业务经理姓"
          style="width: 160px"
        />
      </a-form-model-item>
      <a-form-model-item label="创建时间">
        <a-range-picker
          v-model="dateRange"
          @change="onDateChange"
          format="YYYY-MM-DD"
          valueFormat="YYYY-MM-DD"
          style="width: 260px"
        />
      </a-form-model-item>
      <a-form-model-item label="推送状态">
        <a-select
          allowClear
          v-model="ajaxparams.push_to_user_id_no"
          placeholder="请选择"
          style="width: 120px"
        >
          <a-select-option :value="1">已推送</a-select-option>
          <a-select-option :value="0">未推送</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="支付状态">
        <a-select
          allowClear
          v-model="ajaxparams.is_payed"
          placeholder="请选择"
          style="width: 120px"
        >
          <a-select-option :value="1">已支付</a-select-option>
          <a-select-option :value="0">未支付</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="读取状态">
        <a-select
          allowClear
          v-model="ajaxparams.is_read"
          placeholder="请选择"
          style="width: 120px"
        >
          <a-select-option :value="1">已读</a-select-option>
          <a-select-option :value="0">未读</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button icon="search" type="primary" @click="$refs.myTable.search()"
          >搜索</a-button
        >
        <a-button @click="reset" style="margin-left: 8px">重置</a-button>
      </a-form-model-item>
    </a-form-model>
    <MyTable
      class="mt10"
      :apiUrl="bookingOrders_index"
      :params="ajaxparams"
      ref="myTable"
      :columns="columns"
      :isSelection="false"
    >
      <template slot="manager_id" slot-scope="item, row, index">
        <div>
          {{
            findManager(
              row.user && row.user.manager_id ? row.user.manager_id : undefined
            )
          }}
        </div>
      </template>
      <template slot="user_name" slot-scope="item, row, index">
        <div>{{ row.user ? row.user.name : "" }}</div>
      </template>
      <template slot="goods_name" slot-scope="item, row, index">
        <div>{{ row.goods ? row.goods.goods_name : "" }}</div>
      </template>
      <template slot="spec_desc" slot-scope="item, row, index">
        <div>{{ row.spec ? row.spec.desc : "" }}</div>
      </template>
      <template slot="is_payed" slot-scope="item, row, index">
        <span>{{ Number(row.is_payed) === 1 ? "是" : "否" }}</span>
      </template>
      <template slot="is_read" slot-scope="item, row, index">
        <span>{{ Number(row.is_read) === 1 ? "是" : "否" }}</span>
      </template>
      <template slot="is_cancel" slot-scope="item, row, index">
        <span>{{ Number(row.is_cancel) === 1 ? "是" : "否" }}</span>
      </template>
      <template slot="is_del" slot-scope="item, row, index">
        <span>{{ Number(row.is_del) === 1 ? "是" : "否" }}</span>
      </template>
    </MyTable>
  </div>
</template>
<script>
import MyTable from "@/components/myTable.vue";
import { bookingOrders_index as bookingOrdersIndex } from "@/api/bookingOrders";
import { manager_user_index } from "@/api/manager";
export default {
  name: "BookingOrdersIndex",
  components: { MyTable },
  data() {
    return {
      bookingOrders_index: bookingOrdersIndex,
      user: [],
      ajaxparams: {
        goods_name_no: "",
        manager_name_no: "",
        create_at_between: "",
        push_to_user_id_no: undefined,
        is_payed: undefined,
        is_read: undefined,
      },
      dateRange: [],
      columns: [
        { title: "记录ID", dataIndex: "id", key: "id", width: 100 },
        {
          title: "业务经理",
          dataIndex: "user.manager_id",
          key: "manager_id",
          width: 160,
          scopedSlots: { customRender: "manager_id" },
        },
        {
          title: "推送用户ID",
          dataIndex: "push_to_user_id",
          key: "push_to_user_id",
          width: 120,
        },
        {
          title: "用户名",
          key: "user_name",
          scopedSlots: { customRender: "user_name" },
          width: 160,
        },
        {
          title: "商品名称",
          key: "goods_name",
          scopedSlots: { customRender: "goods_name" },
          width: 200,
          ellipsis: true,
        },
        {
          title: "规格描述",
          key: "spec_desc",
          scopedSlots: { customRender: "spec_desc" },
          width: 260,
          ellipsis: true,
        },
        { title: "数量", dataIndex: "num", key: "num", width: 100 },
        {
          title: "基础数量",
          dataIndex: "base_num",
          key: "base_num",
          width: 100,
        },
        {
          title: "是否支付",
          key: "is_payed",
          scopedSlots: { customRender: "is_payed" },
          width: 100,
        },
        {
          title: "是否已读",
          key: "is_read",
          scopedSlots: { customRender: "is_read" },
          width: 100,
        },
        {
          title: "推送次数",
          dataIndex: "push_times",
          key: "push_times",
          width: 100,
        },
        {
          title: "是否取消",
          key: "is_cancel",
          scopedSlots: { customRender: "is_cancel" },
          width: 100,
        },
        {
          title: "是否刪除",
          key: "is_del",
          scopedSlots: { customRender: "is_del" },
          width: 100,
        },
        {
          title: "创建时间",
          dataIndex: "create_at",
          key: "create_at",
          width: 180,
        },
        {
          title: "更新时间",
          dataIndex: "update_at",
          key: "update_at",
          width: 180,
        },
      ],
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    async getUser() {
      const res = await manager_user_index();
      this.user = res || [];
    },
    findManager(manager_id) {
      if (!manager_id) return "";
      const target = this.user.find((obj) => obj.id == manager_id);
      return target ? target.manager_name : "";
    },
    reset() {
      this.ajaxparams = {
        goods_name_no: "",
        manager_name_no: "",
        create_at_between: "",
        push_to_user_id_no: undefined,
        is_payed: undefined,
        is_read: undefined,
      };
      this.dateRange = [];
      this.$refs.myTable.search();
    },
    onDateChange(value, dateString) {
      this.dateRange = value;
      const arr = Array.isArray(dateString) ? dateString : [];
      const start = arr[0];
      const end = arr[1];
      this.ajaxparams.create_at_between =
        start && end ? `${start} - ${end}` : "";
    },
  },
};
</script>
<style scoped>
</style>